import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InventoryOverview from './InventoryOverview';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: 15
    }
}));

export default function Dashboard() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <h1>Dashboard</h1>
            <InventoryOverview />
        </div>
    );
}
